import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-40db8522"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "selectedtopics" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Card = _resolveComponent("Card")!
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_spin, {
      tip: "加载中...",
      spinning: _ctx.loading
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Card, {
          gutter: 22,
          span: 6,
          courses: _ctx.list,
          isSubject: true,
          onGotoSpecialCourse: _ctx.gotoSpecialCourse
        }, null, 8, ["courses", "onGotoSpecialCourse"])
      ]),
      _: 1
    }, 8, ["spinning"])
  ]))
}